// Permanent redirect — /prompt-builder folded into the /analysis-setup hub
// (criteria step). ProfilesWorkbench/StageBindingsTab now render there;
// this file only round-trips search params to the equivalent hub tab.
import { createFileRoute, redirect } from '@tanstack/react-router';

// Keeping profileId/tab optional (not inferred as always-present-but-possibly-
// undefined) matches the pre-redirect schema and accepts bare `/prompt-builder`
// (no search at all) from old bookmarks/history entries.
interface PromptBuilderSearch {
  profileId?: string;
  tab?: 'stages';
}

export const Route = createFileRoute('/prompt-builder')({
  validateSearch: (search: Record<string, unknown>): PromptBuilderSearch => ({
    profileId: typeof search.profileId === 'string' ? search.profileId : undefined,
    tab: search.tab === 'stages' ? 'stages' : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/analysis-setup/categories',
      search: {
        profileId: search.profileId,
        tab:
          search.tab === 'stages' ? 'stages' : search.profileId ? 'profiles' : undefined,
      },
      replace: true,
    });
  },
});
